var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoading)?_c('div',{staticClass:"loading"},[_vm._m(0),_c('div',{staticClass:"overlay"})]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stage"},[_c('div',{staticClass:"dot-falling"})])
}]

export { render, staticRenderFns }